<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{
            timeTrackingProject.id
                ? 'time-tracking.createProjectPage.editProject'
                : 'time-tracking.createProjectPage.createNewProject'
        }}"
        [back]="true"
    ></app-header>
    <form #form="ngForm">
        <ui-card>
            <app-segment-header title="time-tracking.generalInformation"> </app-segment-header>
            <div class="app-grid">
                <mat-form-field class="columns-4">
                    <mat-label>{{ 'time-tracking.createProjectPage.name' | appTranslate }}</mat-label>
                    <input
                        required
                        matInput
                        type="text"
                        name="projectName"
                        #projectName="ngModel"
                        [(ngModel)]="timeTrackingProject.name"
                    />
                    <mat-error *ngIf="projectName.invalid">{{ projectName.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
            <div class="app-grid">
                <mat-form-field class="columns-4">
                    <mat-label>{{ 'time-tracking.createProjectPage.description' | appTranslate }}</mat-label>
                    <textarea
                        #description="ngModel"
                        name="description"
                        [(ngModel)]="timeTrackingProject.description"
                        [maxlength]="250"
                        matInput
                    >
                    </textarea>
                    <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
                    <mat-hint>{{ description.control.value?.length ?? 0 }} / 250</mat-hint>
                </mat-form-field>
            </div>
            <div class="app-grid" *ngIf="isAdmin">
                <mat-form-field class="columns-4">
                    <mat-label appRemoveAriaOwns>{{
                        'time-tracking.createProjectPage.approvalFlow' | appTranslate
                    }}</mat-label>
                    <mat-select [(ngModel)]="timeTrackingProject.approvalFlow" name="approvalFlow">
                        <mat-option *ngFor="let approvalFlow of approvalFlows | keyvalue" [value]="approvalFlow.key">
                            {{ approvalFlow.value | appTranslate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="app-grid" *ngIf="isOwnerApprovalFlow() && isAdmin">
                <mat-form-field class="columns-4">
                    <mat-label appRemoveAriaOwns>{{
                        'time-tracking.createProjectPage.projectOwners' | appTranslate
                    }}</mat-label>
                    <mat-select name="projectOwner" [formControl]="ownersFC" multiple>
                        <mat-option *ngFor="let owner of potentialOwners" [value]="owner.id">
                            {{ owner.fullName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ui-card>
    </form>

    <ui-card>
        <app-segment-header title="time-tracking.assignedEmployees"> </app-segment-header>

        <app-assign-employees-project-table
            [employees]="employees"
            [project]="timeTrackingProject"
            (onEmployeesChange)="setupProjectEmployeeAssignments($event)"
            (onRemoveChange)="onDeleteAssignment($event)"
            [allowModification]="!timeTrackingProject.isArchived"
        ></app-assign-employees-project-table>
    </ui-card>

    <div class="flex buttons justify-end">
        <ui-button type="link" (click)="onCancel()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="primary" (click)="onSave(form)">{{ 'save' | appTranslate }}</ui-button>
    </div>
</div>
